import $store from '@/store'
import Mustache from 'mustache'
import Settings from '@/models/settings'
import ChannelModel from './channel.js'


export default {

	get_instance(instance) {
		if (typeof(instance) == "object") return instance;
		return this.instance_by_id(instance);
	},
	instance_by_id(instance_id) {
		return $store.state.instances[instance_id];
	},

	title (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) != "undefined") return i.title;
		return;
	},
	channel (instance) {
  	var ch_uuid = instance.meta.channel;
		if (typeof(ch_uuid) != "undefined") {
			return $store.state.channels_uuid[ch_uuid];
		}
		return;
	},
	is_type_channel (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return false;
		return i.type == "input" || i.type == "output"
	},
	is_type_input_channel (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return false;
		return i.type == "input"
	},
	is_type_headend (instance) {
		var i = this.get_instance(instance)
		if (typeof(i) == "undefined") return false;
		return i.type == "headend";
	},
	is_type_transcoder (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return false;
		return i.type == "transcoder";
	},
	is_headend_preview (instance) {
		var i = this.get_instance(instance)
		if (typeof(i) == "undefined") return false;
		return i.meta.preview;
	},
	status (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return;
		return $store.state.instance_status[i.id];
	},
	is_online (instance) {
		var i = this.get_instance(instance)
		if (typeof(i) == "undefined") return false;
		var info = this.status(instance);
		if (typeof(info) != "undefined") return true;
		return false;
	},
	studio_url (instance, port) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return "";

		var ip = _.get(i, "system_info.ip");
		var protocol = "https:";
		var http_port = port || (i.meta.https_port ? i.meta.https_port : '8070');

		var ip_parts = ip.split(".");
		var host_str = "streamer-";
		for (const ipp in ip_parts) {
			var ip_num = parseInt(ip_parts[ipp], 10);
			var ip_hex = ip_num.toString(16).padStart(2, '0');
			host_str = host_str + ip_hex;
		}
		ip = host_str + ".kepit.studio"
		if (typeof(ip) != "undefined") {
			return protocol + "//"+ip+":"+http_port+"/";
		}
		return "";
	},
	gui_url (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return "";

		var protocol = "http:"
		var ip;
		if( typeof(i.meta.primary_ip) != "undefined") ip = i.meta.primary_ip
		else ip = _.get(i, "system_info.ip")

		var http_port = i.meta.http_port ? i.meta.http_port : '8080';

		if (i.type == "input" && i.meta.transcoder == true) {
			protocol = "https:";
			http_port = i.meta.https_port ? i.meta.https_port : '8070';

			var ip_parts = ip.split(".");
			var host_str = "streamer-";
			for (const ipp in ip_parts) {
				var ip_num = parseInt(ip_parts[ipp], 10);
				var ip_hex = ip_num.toString(16).padStart(2, '0');
				host_str = host_str + ip_hex;
			}
			ip = host_str + ".kepit.studio"
		} 

		if (typeof(ip) != "undefined") {
			return protocol + "//"+ip+":"+http_port+"/";
		}
		return "";
	},
	ssh_url (instance) {
		var i = this.get_instance(instance)
		if (typeof(i) == "undefined") return "";

		var ip;
		if( typeof(i.meta.primary_ip) != "undefined") ip = i.meta.primary_ip
		else ip = _.get(i, "system_info.ip")

		if (typeof(ip) != "undefined") {
			return "ssh://kepit@"+ip;
		}
		return "";
	},
	ssh_password (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return "";
		return i.token.slice(-10);
	},
	vnc_url (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return "";

		var ip;
		if( typeof(i.meta.primary_ip) != "undefined") ip = i.meta.primary_ip
		else ip = _.get(i, "system_info.ip")

		if (typeof(ip) != "undefined") {
			return "vnc://"+ip;
		}

		return "";
	},
	preview_config (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) == "undefined") return;
		return Settings.get_by_name(i.meta.preview_config);
	},
	headend_preview_url (instance, channel_uuid) {
		var i = this.get_instance(instance);
		if (!this.is_headend_preview(i)) return;
		var c = $store.state.channels_uuid[channel_uuid];
		if (typeof(c) == "undefined") return;
		var conf = this.preview_config(i);
		if (!conf || typeof(conf.value) != "object" || !conf.value.monitor_url) return;
		return Mustache.render(conf.value.monitor_url, {instance: i, channel: c});
	},
	version (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) != "undefined") {
			return _.get(i, "system_info.version");
		}
		return;
	},
	streamer_version (instance) {
		var i = this.get_instance(instance);
		if (typeof(i) != "undefined") {
			return _.get(this.status(i), ["stats", "streamer", "version"], "");
		}
		return;
	},

	restart_streamer (instance, success, fail) {
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "restart_streamer", "instance": instance.id}}).then((msg) => {
    	console.log("Instance streamer restarted", msg);
			success(msg);
    }).catch((msg) => {
    	console.log("Instance streamer restart failed", msg);
    	fail(msg);
    });
	},

	start_streamer (instance, success, fail) {
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "start_streamer", "instance": instance.id}}).then((msg) => {
			console.log("Instance streamer started", msg);
			success(msg);
		}).catch((msg) => {
			console.log("Instance streamer start failed", msg);
			fail(msg);
		});
	},

	stop_streamer (instance, success, fail) {
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "stop_streamer", "instance": instance.id}}).then((msg) => {
			console.log("Instance streamer stopped", msg);
			success(msg);
		}).catch((msg) => {
			console.log("Instance streamer stop failed", msg);
			fail(msg);
		});
	},

	update_streamer (instance, success, fail) {
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "update_streamer", "instance": instance.id}}).then((msg) => {
			console.log("Instance streamer updated", msg);
			success(msg);
		}).catch((msg) => {
			console.log("Instance streamer update failed", msg);
			fail(msg);
		});
	},
	send_streamer (instance, message, success, fail) {
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "streamer", "message": message, "instance": instance.id}}).then((msg) => {
			console.log("Instance streamer command", msg);
			success(msg);
		}).catch((msg) => {
			console.log("Instance streamer command failed", msg);
			fail(msg);
		});
	},
	stop_transcoder (instance, success, fail) {
		var self = this;
    var r = confirm("Stop transcoder?")
    if (r == true) {
			$store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "stop", "instance": instance.id}}).then((msg) => {
				success(msg);
			}).catch((msg) => {
      	fail(msg);
			});
    }
  	},

	send_command_to_external_device(instance, command, args, success, fail) {
		var self = this;
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "send_command_to_external_device", "instance": instance.id, "command": command, "args": args}}).then((msg) => {
			success(msg);
		}).catch((msg) => {
    	fail(msg);
		});
	},


	mediamtx_get_instance_by_channel(channel) {
		var ch = ChannelModel.get_channel(channel);
		if (_.isEmpty(ch)) return;

   		var i_status = $store.state.instance_status;
   		var instance_id = undefined;
   		var status = _.each(i_status, (info, id) => {
   			if (typeof(info.stats.mtx_streams) != "undefined") {
	   			if (info.stats.mtx_streams.includes(ch.name)) {
   					instance_id = id;
   				};
   			}
   		});
   		if (typeof(instance_id) == "undefined" || instance_id == null) return;
   		return this.get_instance(instance_id);
	},

	mediamtx_add_update_pull(instance, channel_name, url, success, fail) {
		var self = this;
		if (instance == null) {
			instance = this.instances_by_type("mediamtx",false)[0];
		}
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "mediamtx_add_update_pull", "instance": instance.id, "channel": channel_name, "url": url}}).then((msg) => {
			success(msg);
		}).catch((msg) => {
    	fail(msg);
		});
	},

	mediamtx_remove_pull(instance, channel_name, success, fail) {
		var self = this;
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "mediamtx_remove_pull", "instance": instance.id, "channel": channel_name}}).then((msg) => {
			success(msg);
		}).catch((msg) => {
    	fail(msg);
		});
	},

	mediamtx_kick(instance, id, type, success, fail) {
		var self = this;
		$store.dispatch("send_control", {"type": "instance", "payload": {"type": "mediamtx_kick", "instance": instance.id, "id": id, "stream_type": type}}).then((msg) => {
			success(msg);
		}).catch((msg) => {
    	fail(msg);
		});
	},

	types () {
		return [
				{label: "Input", value: "input"},
    		{label: "Output", value: "output"},
    		{label: "Headend", value: "headend"},
    		{label: "Transcoder", value: "transcoder"},
				{label: "Clipper", value: "clipper"},
				{label: "External device", value: "external_device"},
				{label: "MediaMTX", value: "mediamtx"}
		];
	},
	instances_by_type (type, developer) {
		if (typeof(developer) == "undefined") developer = false;
   var i_status = $store.state.instance_status;
   var list = _.map(i_status, (info, id) => {
   	return this.instance_by_id(id);
   });
   var ret = _.filter(list, (info) => {
   	if (typeof(info) == "undefined") return false;
   	if (typeof(info.meta) != "undefined") {
	   if (info.meta.is_developer == true && developer == false) return false;
   	}
   	if (developer == false) {
	   	return info.type == type;
	 } else {
	 	return (info.type == type && info.meta.is_developer == true);
	 }
   });
   return ret;
	}
}
